<template>
  <tr>
    <td>
      <img
        :src="item.product.url_image_flask"
        :alt="item.product.name"
        class="img-product-cart"
      />
    </td>
    <td>
      <div class="mt-10">
        <span class="font-general-l">
          <a style="color: #14365b" :href="`/helado-sabor/${item.product.slug}/${item.product.id}`">{{ item.product.name }}</a>
        </span>
        <p class="color-blue font-general-l">{{ item.option_size }}</p>
      </div>
    </td>
    <td style="width: 100px">
      <p class="mt-10 font-general-l color-blue">
        {{ currencyFormat(item.price) }}
      </p>
    </td>
    <td style="width: 100px">
      <p class="mt-10 color-blue font-general-l text-center">
        {{ item.quantity }}
      </p>
    </td>
    <td style="width: 100px">
      <p :class="`text-center mr-2 mt-10 font-general-l ${item.discount ? 'price-discount text-danger' : 'color-blue' }`">
        {{
          currencyFormat(item.subtotal)
        }}
      </p>
    </td>
    <td style="text-align:center">
      <v-btn
        v-if="item.hasOwnProperty('id')"
        class="mt-8"
        color="accent"
        text
        :loading="loading_btn_remove_cart"
        @click="removeItemCart(item.id)"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-btn
        v-else
        class="mt-8"
        color="accent"
        text
        :loading="loading_btn_remove_cart"
        @click="removeItemCart(item.product.id)"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { currencyFormat } from '@/helpers'
export default {
  props: ['item'],
  data: () => ({
    loading_btn_remove_cart: false
  }),
  methods: {
    currencyFormat(price) {
			return currencyFormat(price)
    },
    removeItemCart(item_id) {
			try {
        this.loading_btn_remove_cart = true
        setTimeout(() => {
          this.$store.dispatch('removeItemCart', { id: item_id })
          this.loading_btn_remove_cart = false
        }, 500)
			} catch (error) {
				this.$notify({
					group: 'admin',
					title: 'Ocurrio un problema: '.error.message,
					type: 'success',
				})
			}
		},
  }
}
</script>

<style scoped>
  p, span {
    font-size: 18px !important
  }
</style>
